import { LayerConfig, LayerStyle } from "fond/types/ProjectLayerConfig";

// Mapbox source & layers displaying the identified parcels
export const OVERLAY_SOURCE_ID = "identified-street-parcels";
export const OVERLAY_FILL_ID = "identified-street-parcels-fill";
export const OVERLAY_OUTLINE_ID = "identified-street-parcels-outline";

const OVERLAY_LAYER_ID = "identified-street-parcels-layer";
const OVERLAY_COLOR = "#e1373b";

/** Map styles highlighting the identified parcels. */
export const OVERLAY_STYLES: LayerStyle[] = [
  {
    ID: OVERLAY_FILL_ID,
    Name: OVERLAY_FILL_ID,
    Type: "STYLE",
    GlobalPosition: 0,
    ConfigurationID: OVERLAY_LAYER_ID,
    ConfigurationType: "LAYER",
    Position: 0,
    MapboxStyle: {
      type: "fill",
      paint: { "fill-color": OVERLAY_COLOR, "fill-opacity": 0.35 },
    },
    RawStyles: { Type: "fill", FillColor: OVERLAY_COLOR, FillOpacity: 0.35 },
  },
  {
    ID: OVERLAY_OUTLINE_ID,
    Name: OVERLAY_OUTLINE_ID,
    Type: "STYLE",
    GlobalPosition: 1,
    ConfigurationID: OVERLAY_LAYER_ID,
    ConfigurationType: "LAYER",
    Position: 1,
    MapboxStyle: {
      type: "line",
      paint: { "line-color": OVERLAY_COLOR, "line-width": 2 },
    },
    RawStyles: { Type: "line", LineColor: OVERLAY_COLOR, LineWidth: 2 },
  },
];

/**
 * Layer config for the identified parcels overlay.
 *
 * Note the outline style is listed first as SourceAndLayers renders `Styles[0]` on top.
 */
export const OVERLAY_LAYER_CONFIG: LayerConfig = {
  ID: OVERLAY_LAYER_ID,
  Label: "Identified street parcels",
  Key: OVERLAY_SOURCE_ID,
  Type: "LAYER",
  IsVisible: true,
  Hidden: false,
  Styles: [OVERLAY_OUTLINE_ID, OVERLAY_FILL_ID],
  Position: 0,
  GlobalPosition: 0,
  GeometryType: "Polygon",
  ParentID: null,
  MaxZoomLevel: null,
  MinZoomLevel: null,
  Children: [],
};
